import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SeoCoursePageFaqListComponent } from './seo-course-page-faq-list/seo-course-page-faq-list.component';
import { SeoCoursePageFaqCreateComponent } from './seo-course-page-faq-create/seo-course-page-faq-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: SeoCoursePageFaqListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: SeoCoursePageFaqCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'seo-course-page-faq-create/:id',
        component: SeoCoursePageFaqCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SeoCoursePageFaqRoutingModule { }
